// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__viSAp","body":"Layout_body__5eB00"};